import { Detection } from 'src/data-capture/types';
import { DetectionState, EntityCategory, Categories } from '../useDetectedEntitiesStore';
import extractCategoriesForDetection from './extractCategoriesForDetection';
import { filterConflictsByFields } from './filterConflictsByFields';

export const getUpdatedDetectionState = (
  existingDetectionState: DetectionState,
  newDetection: Detection,
): DetectionState => {
  const updatedState: DetectionState = {
    ...existingDetectionState,
  };

  const updatedFieldsByKey = { ...existingDetectionState.fieldsByKey };
  Object.keys(updatedFieldsByKey).forEach(fieldName => {
    if (
      newDetection.entity.fields[fieldName] !== undefined &&
      !updatedFieldsByKey[fieldName].isLocallyEdited
    ) {
      updatedFieldsByKey[fieldName] = {
        ...updatedFieldsByKey[fieldName],
        value: newDetection.entity.fields[fieldName],
      };
    }
  });

  updatedState.fieldsByKey = updatedFieldsByKey;
  updatedState.conflicts = filterConflictsByFields(
    newDetection.conflicts.map(c => ({
      id: c.conflictingEntityFields.id,
      conflictingEntityFields: c.conflictingEntityFields,
      conflictingFields: c.conflictingFields,
    })),
    Object.keys(updatedFieldsByKey),
  );

  return updatedState;
};

export const addToCategories = (
  existingCategories: Categories,
  newCategoriesForDetection: ReturnType<typeof extractCategoriesForDetection>,
  entityType: string,
  detectionId: string,
) => {
  Object.entries(newCategoriesForDetection).forEach(([category, categoryData]) => {
    const categoryKey = category as EntityCategory;

    if (!existingCategories[categoryKey][entityType]) {
      existingCategories[categoryKey][entityType] = {};
    }

    existingCategories[categoryKey][entityType][detectionId] = categoryData;
  });
};
